/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Range
 */
export interface Range {
    /**
     * 
     * @type {number}
     * @memberof Range
     */
    minimum: number;
    /**
     * 
     * @type {number}
     * @memberof Range
     */
    maximum: number;
    /**
     * 
     * @type {string}
     * @memberof Range
     */
    name: string;
}

/**
 * Check if a given object implements the Range interface.
 */
export function instanceOfRange(value: object): value is Range {
    if (!('minimum' in value) || value['minimum'] === undefined) return false;
    if (!('maximum' in value) || value['maximum'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function RangeFromJSON(json: any): Range {
    return RangeFromJSONTyped(json, false);
}

export function RangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Range {
    if (json == null) {
        return json;
    }
    return {
        
        'minimum': json['minimum'],
        'maximum': json['maximum'],
        'name': json['name'],
    };
}

export function RangeToJSON(value?: Range | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'minimum': value['minimum'],
        'maximum': value['maximum'],
        'name': value['name'],
    };
}

